var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.medicalReportLoading) ? _c('div', {
    staticClass: "card-body row m-0"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.clientAnamnesis !== false) ? _vm._l((_vm.clientAnamnesis), function(ca) {
    return _c('anamnesis-editor', {
      attrs: {
        "anamnesis": ca,
        "force-save": _vm.forceSave
      },
      on: {
        "saved": _vm.anamnesisSaved
      }
    })
  }) : _vm._e(), _vm._v(" "), [_c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "target": "_blank",
      "role": "button",
      "data-testid": "visit-medical-report-print",
      "href": _vm.hostname.hostname + 'visit/' + _vm.$route.params.visitid + '/medical_report/pdf'
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Tisknout zprávu\n        ")])], _vm._v(" "), (_vm.medicalReportText !== '') ? [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-medical-report-existing"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Stará lékařská zpráva")]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    domProps: {
      "innerHTML": _vm._s(_vm.medicalReportText)
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "visit-medical-report-history"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === index ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'visit-medical-report-history-row-' + index
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === index) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'visit-medical-report-history-toggle-' + index
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'visit-medical-report-history-toggle-' + index
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(task.date_cs))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [(task.type === 'lab_result') ? _c('span', [_c('i', {
      staticClass: "fa fa-flask fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Laboratorní výsledek")]) : _c('span', [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Lékařská zpráva")])]), _c('td', {
      staticClass: "col-sm-5"
    })]), _vm._v(" "), (_vm.openedTaskId === index) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'visit-medical-report-history-detail-' + index
      }
    }, [(task.type === 'lab_result') ? _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Laboratorní výsledek")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      }
    }), _vm._v(" "), _c('b', [_vm._v("Hodnocení")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.evaluation)
      }
    })]) : _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'visit-medical-report-history-copy-' + index
      },
      on: {
        "click": function($event) {
          _vm.copyAndInsertReport(task.text)
        }
      }
    }, [_vm._v("Zkopírovat")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.text)
      }
    }), _vm._v(" "), (task.visit) ? [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((task.visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(task.visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((task.visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])])]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a93563","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/MedicalReportNew.vue
// module id = 556
// module chunks = 0